// ProductItem.tsx
import {
  ProductInterface,
} from "../../pages/OrderDetailsPage/OrderDetailsInterface";

interface ProductItemProps {
  product: ProductInterface;
  detailId?: string;
}

export const ProductItem = ({ product }: ProductItemProps) => {
  
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };

  return (
    <div className="flex items-start gap-4 py-4 border bg-white border-gray-200 px-4 rounded-lg m-4">
      {/* Product Image */}
      <div className="w-16 h-16 rounded-md overflow-hidden bg-gray-100 flex-shrink-0">
        {product.images && product.images.length > 0 ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
            <span className="text-gray-400 text-xs">No image</span>
          </div>
        )}
      </div>

      {/* Product Details */}
      <div className="flex-grow">
        <h3 className="font-medium text-gray-900 text-base">{product.name}</h3>

        {/* Variant shown as a pill/badge */}
        {product.product_variants && product.product_variants.length > 0 && (
          <div className="mt-1 flex flex-wrap gap-2">
            {product.product_variants.map((variant) => (
              variant.attributes.map((attribute) => {
                const isColorVariant = 'color' in attribute;
                const displayValue = isColorVariant 
                  ? attribute.color.name 
                  : attribute.value;
                
                return (
                  <span
                    key={`${variant.id}-${attribute.name}`}
                    className="inline-block bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full"
                  >
                    {attribute.name}: {displayValue}
                  </span>
                );
              })
            ))}
          </div>
        )}

        {/* SKU Line */}
        <p className="mt-1 text-xs text-gray-500">SKU: {product.product_id}</p>

        {/* Price x Quantity Line */}
        <div className="text-right flex flex-row justify-between">
          <p className="mt-1 text-sm text-gray-600">
            {formatCurrency(product.unit_price_with_discount)} × {product.units || 1}
          </p>
          {/* Total Price - Right Aligned */}
          <p className="font-medium text-gray-900">
            {formatCurrency(product.total_value_with_discount)}
          </p>
        </div>
      </div>
    </div>
  );
};
